import { Injectable } from '@angular/core';
import * as io from 'socket.io-client';
import { Observable } from 'rxjs/Observable';
import * as Rx from 'rxjs';
import { environment } from '../../environments/environment';
import { DataService } from './data.service';

@Injectable()
export class WebsocketService {
    private socket;

    constructor(private dataService: DataService) { }

    connect(): Rx.Subject<MessageEvent> {
        this.socket = io(environment.webSocketUrl);

        const publisherId = this.dataService.publisherId;
        if (publisherId != null) {
            var entity = { publisherId: publisherId };
            this.socket.emit('joinGroup', entity);
        }

        let observable = new Observable(observer => {
            this.socket.on('message', data => {
                console.log('Received message from Websocket Server');
                observer.next(data);
            });
            return () => {
                this.socket.disconnect();
            };
        });

        let observer = {
            next: (data: Object) => {
                this.socket.emit('message', JSON.stringify(data));
            }
        };

        return Rx.Subject.create(observer, observable);
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/_services/websocket.service.ts